export default "__VITE_ASSET__BwNYm1X5__"